import React,{useContext} from 'react'
import {  FooterLogo, Google, LinkedIn, Twitter, Facebbok } from "../LayoutSvg";
import { LanguageContext } from '../../context/LanguageContext';
import './footer.css'
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const Footer = () => {
    const { translations } = useContext(LanguageContext);
  return (
    <div className='footer'>

        <div className='footer_wrapper'>
      <Container>
            <div className="text-center footer_logo">
              {FooterLogo}
            </div>
            <h4 className='text-center pb-3'>{translations.footer?.question}</h4>
            <h5 className='text-center pb-3' dangerouslySetInnerHTML={{ __html: translations.footer?.emailContact }}></h5>
            <h4 className='text-center'>{translations.footer?.legal}</h4>
            <h5 className='text-center pb-3'><Link to="/terms-and-condition">{translations.footer?.terms}</Link> | <Link to="/privacy-policy">{translations.footer?.privacy}</Link> | <Link to="/faqs">{translations.footer?.faq}</Link></h5>
            <h4 className='text-center'>{translations.footer?.followUs}</h4>
            <ul className='social_links d-flex justify-content-center gap-3'>
              <li>
                  <a href="">{Google}</a>
              </li>
              <li>
                  <a href="">{LinkedIn} </a>
              </li>
              <li>
                  <a href="">{Twitter} </a>
              </li>
              <li>
                  <a href="">{Facebbok}</a>
              </li>
            </ul>
      </Container>
      </div>
      <div className='footer_info text-center'>
         <Container>
            <p>{translations.footer?.tagline}</p>

      </Container>
      </div>
    </div>
  )
}

export default Footer